module.exports = __webpack_public_path__ + "img/inst5.9e6a0add.png";